import { HiTrash, HiMinusCircle } from 'react-icons/hi';

import Button from '@/tayara-kit/Button';
import Text from '@/tayara-kit/Text';

const DeleteAccountTab = ({ setShowModal }: any) => (
  <>
    <Text
      as="h2"
      text="Supprimer le compte"
      className="text-2xl text-primary font-bold mb-4 "
    />
    <div className=" flex  flex-wrap w-full  border  border-dashed border-primary rounded-lg p-5 gap-4 justify-between  ">
      <div className="flex text-primary h-fit self-center w-fit md:basis-[60%] ">
        <HiMinusCircle
          size={40}
          className=" hidden md:inline lg:inline  lg:top-0.5 lg:left-0 lg:mr-4 relative -top-2 -left-2 lg:self-center"
        />
        <p className="text-primary text-base lg:self-center w-fit">
          En effectuant cette action votre compte et vos annonces seront
          supprimées définitivement !
        </p>
      </div>

      <Button
        onClick={() => setShowModal(true)}
        aria-label="Supprimer mon compte"
        className="flex justify-end w-full md:w-auto lg:w-auto !border !border-dashed !border-primary hover:!border-solid hover:!bg-white rounded-lg text-primary text-l "
        title="Supprimer mon compte"
        icon={<HiTrash className="mr-2" />}
      >
        Supprimer mon compte
      </Button>
    </div>
  </>
);
export default DeleteAccountTab;
